import { SET_SPORTSBOOK_HEADER_FILTERS } from 'Store/constants';

const initialState = {
  text: '',
  isFocussed: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_SPORTSBOOK_HEADER_FILTERS:
      return {
        ...state,
        ...action.payload,
      };
    
    default:
      return state;
  }
};